import * as RoutePathConstants from '../../../constants/RoutePathConstants'
import myCoupon from './views/my-coupon'

export default [
  {
    path: RoutePathConstants.MY_COUPON,
    name: 'myCoupon',
    component: myCoupon
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/member-coupon/routers.js